module.exports = __webpack_public_path__ + "media/src/images/partners/tsu-8c020482985cc3b2d29edcef5bd36632.jpg";